import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const Route = createFileRoute("/admin/faq")({ component: AdminFaq });

function AdminFaq() {
  const [rows, setRows] = useState<any[]>([]);
  async function load() {
    const { data } = await supabase.from("faq_items").select("*").order("sort_order");
    setRows(data ?? []);
  }
  useEffect(() => { load(); }, []);
  async function save(r: any) {
    const { error } = await supabase.from("faq_items").update({ question: r.question, answer: r.answer, sort_order: r.sort_order, active: r.active }).eq("id", r.id);
    if (error) toast.error(error.message); else toast.success("Guardado");
  }
  async function add() {
    const { error } = await supabase.from("faq_items").insert({ question: "Nueva pregunta", answer: "Respuesta", sort_order: (rows.at(-1)?.sort_order ?? 0) + 10 });
    if (error) toast.error(error.message); else load();
  }
  async function del(id: string) {
    if (!confirm("¿Eliminar?")) return;
    const { error } = await supabase.from("faq_items").delete().eq("id", id);
    if (error) toast.error(error.message); else load();
  }
  return (
    <div>
      <div className="flex items-center justify-between">
        <h2 className="font-display text-xl font-semibold text-foreground">FAQ</h2>
        <Button size="sm" onClick={add} className="bg-primary text-primary-foreground hover:bg-primary/90">+ Añadir</Button>
      </div>
      <div className="mt-4 space-y-3">
        {rows.map((r, i) => (
          <div key={r.id} className="rounded-md border border-hairline bg-surface p-4 space-y-2">
            <Input className="bg-surface-2 border-hairline" value={r.question} onChange={(e) => setRows((p) => p.map((x, j) => j === i ? { ...x, question: e.target.value } : x))} />
            <Textarea className="bg-surface-2 border-hairline" value={r.answer} onChange={(e) => setRows((p) => p.map((x, j) => j === i ? { ...x, answer: e.target.value } : x))} />
            <div className="flex items-center gap-3">
              <Input className="bg-surface-2 border-hairline w-24" type="number" value={r.sort_order} onChange={(e) => setRows((p) => p.map((x, j) => j === i ? { ...x, sort_order: Number(e.target.value) } : x))} />
              <label className="text-xs text-muted-foreground"><input type="checkbox" checked={r.active} onChange={(e) => setRows((p) => p.map((x, j) => j === i ? { ...x, active: e.target.checked } : x))} className="mr-1" />Activo</label>
              <Button size="sm" onClick={() => save(r)} className="bg-primary text-primary-foreground hover:bg-primary/90">Guardar</Button>
              <Button size="sm" variant="outline" className="border-hairline" onClick={() => del(r.id)}>Eliminar</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
